import {API_URL} from "../common/struct/urlManager";
import {post, postWithoutToken} from "../common/methods/ApiService";
import {TEmailSentResponse} from "../interfaces/email";

export async function postEmailContact($params: any): Promise<void> {
  return postWithoutToken(`${API_URL.EMAIL_CONTACT}`, $params);
}
export async function sendEmailContact($params: any): Promise<TEmailSentResponse> {
  return post(`${API_URL.EMAIL_NOTIFICATION}`, $params);
}
